import { render } from "./detalleInmueble.vue?vue&type=template&id=7bf866dd&scoped=true"
import script from "./detalleInmueble.vue?vue&type=script&lang=js"
export * from "./detalleInmueble.vue?vue&type=script&lang=js"

import "./detalleInmueble.vue?vue&type=style&index=0&id=7bf866dd&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf866dd"]])

export default __exports__